<template>
    <div class="appRoot" :class="$route.name">
        <div class="blob blob-1"></div>
        <div class="grid-overlay"></div>
        <div class="spinnerContainer" v-show="$store.state.showSpinner > 0">
            <div class="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <template v-if="showApp">
            <div class="appMode" v-if="showAppMode">Modalità: {{appMode}}</div>
            <div class="appVersion" v-if="showVersion">v{{appVersion}}</div>
            <router-view />
        </template>
        <op-modal-container></op-modal-container>
    </div>
</template>

<script lang="ts">
import store from '@/store';
import { ModalServices } from '@/services/ModalServices'
import { Options, Vue } from 'vue-class-component';
import { mode, appVersion } from './config';
import { LoginServices } from './services/LoginServices';
import { DownloadedFilesServices } from './services/DownloadedFilesServices';
import { NetworkServices } from './services/NetworkServices';
import { getMenuByRole } from './router';

@Options({})
export default class App extends Vue {
    
    showApp: boolean = false;
    appMode: string = "";
    appVersion: string = "";

    created(){
        this.appMode = mode;
        this.appVersion = appVersion;

        document.addEventListener("deviceready", this.onDeviceReady, false);
        document.addEventListener("pause", this.onPause, false);
        document.addEventListener("resume", this.onResume, false);

        ModalServices.setOpModal(this.$opModal);


        if(!window.cordova){
            this.loginDefaultRoutine();
        }
    }

    get showAppMode(){
        if(this.$route.name == "printPreview")
            return false;

        return this.appMode != 'production'
    }

    get showVersion(){
        return this.$route.name != "printPreview"
    }

    loginDefaultRoutine(){
        let authtoken = window.localStorage.getItem('authtoken')
        if(authtoken){
            LoginServices.loginCallback(authtoken)
            .then(x => {
                this.showApp = true;
                if(this.$route.name == 'login'){
                    let menu = getMenuByRole(store.state.user.role)
                    if(menu.commessaPaths[0]){
                        this.$router.push(menu.commessaPaths[0].path);
                    } else {
                        this.$router.push(menu.systemPaths[0].path);
                    }
                }
            })
            .catch(x => {
                this.showApp = true;
            })
        } else {
            this.showApp = true;
        }
    }


    onDeviceReady(){
        store.state.isCordova = !!(<any>window).cordova;
        if (device.platform == 'iOS') {
            store.state.isIos = true;
        } else {
            store.state.isIos = false;
        }


        NetworkServices.refresh();

        DownloadedFilesServices.rehydrateProgress();

        if(window.Keyboard){
            if(device.platform == "iOS"){
                window.Keyboard.hideFormAccessoryBar(false);
            }
        }

        DeepLink.onDeepLink((url) => {
            var hashIndex = url.indexOf('#');
            if (hashIndex < 0)
                return;

            var route = url.substring(hashIndex + 1);
            this.$router.push(route);
        });

        document.addEventListener("backbutton", () => {
            if(store.state.backButtonFunction){
                store.state.backButtonFunction();
            } else {
                if(this.$opModal.modals().length > 0){
                    this.$opModal.closeLast();
                    return;
                }

                if(this.$route.meta.closeAppModal){
                    ModalServices.confirmModal(
                        '',
                        'Vuoi chiudere l\'app?',
                        'Si',
                        'No',
                        () => {
                            (<any>window.navigator).app.exitApp();
                        }
                    )
                } else {
                    this.$router.back();
                }
            }
        }, false);

        window.addEventListener('keyboardWillShow', (event: any) => {
            document.body.classList.add('keyboardopen');
        });
        window.addEventListener('keyboardWillHide', (event) => {
            document.body.classList.remove('keyboardopen');
            let pageContainer = document.querySelector('.appRoot')
            if(pageContainer.scrollHeight <= window.innerHeight){
                pageContainer.scrollTop = 0;
            }
        });
        
        document.addEventListener('online', () => {
            store.state.isOnline = true;
        }, false);
        document.addEventListener('offline', () => {
            store.state.isOnline = false;
        }, false);

        this.loginDefaultRoutine();

    }

    onPause(){

    }

    onResume(){
        NetworkServices.refresh();
        DownloadedFilesServices.rehydrateProgress();
    }

}

</script>
